import type { CalqueOptions, ResolvedCalqueOptions } from './types'

export const CALQUE_DEFAULT_OPTIONS: Readonly<ResolvedCalqueOptions> = Object.freeze({
  post: '',
  title: 'Conversation',
  indentDepth: 100,
  colorScheme: 'auto',
  accent: undefined,
  background: undefined,
})

export const CALQUE_OPTION_NAMES = Object.freeze(
  Object.keys(CALQUE_DEFAULT_OPTIONS) as (keyof CalqueOptions)[],
)

type CalqueOptionValues = Partial<Record<keyof CalqueOptions, string | null | undefined>>

export function parseCalqueOptions(values: CalqueOptionValues): CalqueOptions {
  const options: CalqueOptions = {}

  for (const name of CALQUE_OPTION_NAMES) {
    const value = values[name]?.trim()
    if (!value) continue

    switch (name) {
      case 'post':
      case 'title':
        options[name] = value
        break
      case 'indentDepth':
        options.indentDepth = Number(value)
        break
      case 'colorScheme':
        if (value === 'auto' || value === 'light' || value === 'dark') {
          options.colorScheme = value
        }
        break
      case 'accent':
        options.accent = value
        break
      case 'background':
        options.background = value
        break
    }
  }

  return options
}

export function resolveCalqueOptions(options: CalqueOptions = {}): ResolvedCalqueOptions {
  const post = options.post?.trim() || CALQUE_DEFAULT_OPTIONS.post
  const indentDepth = Number.isFinite(options.indentDepth)
    ? Math.min(1_000, Math.max(1, Math.floor(options.indentDepth!)))
    : CALQUE_DEFAULT_OPTIONS.indentDepth
  const title = options.title?.trim() || CALQUE_DEFAULT_OPTIONS.title
  const colorScheme = options.colorScheme === 'light' || options.colorScheme === 'dark'
    ? options.colorScheme
    : CALQUE_DEFAULT_OPTIONS.colorScheme

  return {
    post,
    title,
    indentDepth,
    colorScheme,
    accent: options.accent?.trim() || CALQUE_DEFAULT_OPTIONS.accent,
    background: options.background?.trim() || CALQUE_DEFAULT_OPTIONS.background,
  }
}
